import React, { FC } from "react";
import MuiSliderComponent, { SliderComponentProps } from "@CubeComponents/Mui_Form/SliderComponent";
import { createUseStyles } from "react-jss";
import { defaultSliderComponentProps } from "../../constants/globalVariable";
import { getSliderParentWrapperStyle, getSliderStyle } from "../../constants/globalFunctions";

const SliderComponent: FC<SliderComponentProps> = (props: SliderComponentProps) => {
  const useStyles = createUseStyles({
    parentWrapper: getSliderParentWrapperStyle(),
    slider: getSliderStyle(
      props.gradientColor1 as string,
      props.gradientColor2 as string,
      props.color as string,
      props.handleShadowColor as string,
      props.handleGradientColor1 as string,
      props.handleGradientColor2 as string,
    ),
  });

  const classes = useStyles() as Record<"parentWrapper" | "slider", string>;

  /*******************
@Purpose : Slider Component
@Parameter : SliderComponentProps
@Author : Techture
 *******************/

  return (
    <div className={classes.parentWrapper}>
      <MuiSliderComponent {...props} type="MinRange" className={classes.slider} />
    </div>
  );
};
// KNOWN BUG, preserved verbatim: `defaultProps` on a function component is ignored by
// React 19, so these defaults never apply. Erased assertion; removing the line would
// change behaviour only if React ever honoured it again.
(SliderComponent as typeof SliderComponent & { defaultProps: typeof defaultSliderComponentProps }).defaultProps =
  defaultSliderComponentProps;
export default SliderComponent;
